var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentPurple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.5c5.385 0 9.75 4.365 9.75 9.75v9.375c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.035.84-1.875 1.875-1.875H10.5zM5.625 3a.375.375 0 0 0-.375.375v17.25c0 .207.168.375.375.375h12.75a.375.375 0 0 0 .375-.375v-9l-.005-.166a2.625 2.625 0 0 0-2.454-2.454L16.125 9h-1.5a1.875 1.875 0 0 1-1.875-1.875v-1.5A2.625 2.625 0 0 0 10.125 3h-4.5zM12 17.25a.75.75 0 1 1 0 1.5H8.25a.75.75 0 1 1 0-1.5H12zm3.75-3a.75.75 0 1 1 0 1.5h-7.5a.75.75 0 1 1 0-1.5h7.5zM13.755 3.668l.026.044c.3.572.469 1.223.469 1.913v1.5c0 .207.168.375.375.375h1.5c.69 0 1.341.17 1.913.47l.043.024-.026-.065a8.28 8.28 0 0 0-4.234-4.234l-.066-.027z",
    fill: "#821BB8",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentPurple);
export default __webpack_public_path__ + "static/media/document-purple.cc8226dfd940cf097e9cd157ae5ba16d.svg";
export { ForwardRef as ReactComponent };